module.exports = __webpack_public_path__ + "img/product.f360c7b0.png";